import React, { useEffect, useRef, useState } from 'react';
import { Formik, Form as FormikForm, Field, ErrorMessage } from 'formik';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as Yup from 'yup';
import { Row, Col, Button, Card, Form, Badge } from 'react-bootstrap';
import PageTitle from '../../../layouts/PageTitle';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import DatePicker from 'react-datepicker';
import { connect, useDispatch, useSelector } from 'react-redux';
import { employeeSearchAction } from '../../../../store/actions/BoxActions';
import { employeeSearchList } from '../../../../store/selectors/BoxSelectors';
import { getProfile } from '../../../../store/selectors/AuthSelectors';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { useLoader } from '../../../../context/LoaderCotext';
import { getBoxFolderOfEmpByEmail } from '../../../../services/BoxFolderOfEmpService';
import Swal from 'sweetalert2';
import { deleteAEAFile } from '../../../../services/FileService';
import axiosInstance from '../../../../services/AxiosInstance';
import { retrieveData, storeData } from '../../../../services/indexedDBUtils';
import {
  getBoxAuthToken,
  getBoxAuthUrl,
  getUsersSearch,
  uploadFileBatch,
} from '../../../../services/BoxService';
import { useAuth } from '../../../../context/authContext';
import Cookies from 'js-cookie';
import { createFormAction } from '../../../../store/actions/FormsActions';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { addHistory, getTuitionsByEmailYear } from '../../../../services/TuitionService';
import { getMTEByEmail } from '../../../../services/MTEService';

const validationSchema = Yup.object({
  employeeName: Yup.object().required('Employee name is required'),
  employeeNumber: Yup.string().required('Employee number is required'),
  date: Yup.date().required('Date is required'),
  phoneNumber: Yup.string().required('Phone Number is required'),
  major: Yup.string().required('Major is required'),
  school: Yup.string().required('School is required'),
  degreeType: Yup.string().required('Degree is required'),
  semesterBegins: Yup.date().required('Semister begining date is required'),
  semesterEnds: Yup.date().required('Semister end date is required'),
  tuitionLimit: Yup.number().required('Tuition limit is required'),
  tuitionUsed: Yup.number().required('Tuition limit used is required'),
  tuitionBenefit: Yup.number().required('Tuition benefit is required'),
  enrolledCourses: Yup.string().required('Enrolled courses is required'),
  totalTuition: Yup.number().required('Total tuition is required'),
  qualifyingBenefit: Yup.number().required('Qualifying benefit amount is required'),
  attachments: Yup.array()
    .min(
      1,
      'At least one file is required or selected file is not supporting, please select (jpeg, jpg, png, pdf).'
    ) // Ensures that at least one file is selected
    .of(
      Yup.mixed()
        .test(
          'fileType',
          'Unsupported file format, please select (jpeg, jpg, png, pdf).',
          (file) => {
            return file && SUPPORTED_FORMATS.includes(file.type);
          }
        )
        .test('fileSize', 'File is too large, please select smaller file', (file) => {
          return file && file.size <= 50000000; // Max file size of 50MB
        })
    )
    .required('Attachments are required'), // This ensures the array is not empty
});
const SUPPORTED_FORMATS = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'];

const AeaForm = ({ profile, employeeList }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const { showLoader, hideLoader } = useLoader();
  const [submitterName, setSubmitterName] = useState('');
  const [folderAPISuccess, setFolderAPISuccess] = useState(false);
  const [cookieValue, setCookieValue] = useState(Cookies.get('boxToken'));
  const [tuition, setTuition] = useState(null);
  const [uploadProgress, setUploadProgress] = useState({}); // To track progress for each file
  const [attachments, setAttachments] = useState([]);
  const [hasDashboardMenu, setHasDashboardMenu] = useState(true);
  const [initialValues, setInitialValues] = useState({
    employeeName: '',
    employeeNumber: '',
    date: moment().toDate(),
    phoneNumber: '',
    major: '',
    school: '',
    degreeType: '',
    semesterBegins: '',
    semesterEnds: '',
    tuitionLimit: '5250',
    tuitionUsed: 0,
    enrolledCourses: '',
    tuitionBenefit: 0,
    totalTuition: 0,
    qualifyingBenefit: 0,
    attachments: [],
    boxFolderId: '310099883829',
    manager: '',
    boxFolderName: 'AEA-Forms',
    timestamp: moment().unix(),
  });

  // const phoneRegExp = /^\d{3}-\d{3}-\d{4}$/

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const authCode = searchParams.get('code');
    const apiCall = async () => {
      if (typeof authCode != 'undefined' && authCode != '' && authCode != null) {
        await getBoxAuthToken(authCode)
          .then(async (response) => {
            if (typeof response.data.key != 'undefined') {
              const expiryDate = new Date();
              expiryDate.setTime(expiryDate.getTime() + response.data.life * 1000);
              Cookies.set('boxToken', response.data.key, {
                expires: expiryDate,
                path: '/',
                secure: true,
              });
              setCookieValue(Cookies.get('boxToken'));
              setFolderAPISuccess(true);
            }
          })
          .catch(async (error) => {});
      } else {
        setFolderAPISuccess(true);
      }
    };
    if (typeof cookieValue == 'undefined' && hasPermission('box-folders', ['show']) == true) {
      apiCall();
    } else {
      setFolderAPISuccess(true);
    }
  }, [cookieValue]);

  useEffect(() => {
    dispatch(employeeSearchAction(''));
  }, [dispatch]);

  useEffect(() => {
    if (typeof profile != 'undefined') {
      setSubmitterName(profile.firstName + ' ' + profile.lastName);
    }
    if (profile && profile.allowedModules) {
      const hasDashboard = profile.allowedModules.some(
        (module) => module.value.trim() === 'dashboard' && module.operations.includes('menu')
      );
      if (hasDashboard == false) {
        setHasDashboardMenu(false);
      }
    }
  }, [profile]);

  const loadOptions = (inputValue, callback) => {
    if (!inputValue) {
      callback([]);
      return;
    }
    getUsersSearch(inputValue)
      .then((response) => {
        const options = response.data.map((employee) => ({
          value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          email: employee.email,
          employeeNumber: employee.employeeNumber,
        }));
        callback(options);
      })
      .catch((error) => {
        console.error('Error fetching employee data', error);
        callback([]);
      });
  };

  const getTuitions = async (email, year, setFieldValue) => {
    await getTuitionsByEmailYear(email, year)
      .then((response) => {
        setTuition(response);
        setFieldValue('tuitionBenefit', response.availableTuitionAmount);
        setFieldValue('tuitionUsed', response.usedTuitionAmount);
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Employee Tuition record',
          text: 'Employee tuition record not find for selected year, Please contact your admin',
          width: 400,
          confirmButtonColor: '#3a7afe',
        });
      });
  };

  const handleEmployeeChange = async (selectedOption, setFieldValue, date = moment().toDate()) => {
    setFieldValue(`employeeName`, selectedOption);
    const folderIdRes = await getBoxFolderOfEmpByEmail(selectedOption.email);
    if (typeof folderIdRes.isError != 'undefined' && folderIdRes.isError == true) {
      Swal.fire({
        icon: 'error',
        title: 'Employee Data Error',
        text: 'Employee data not configured with box, Please contact your admin',
        width: 400,
        confirmButtonColor: '#3a7afe',
      });

      setFieldValue(`email`, '');
      setFieldValue(`manager`, '');
      setFieldValue(`employeeNumber`, '');
      setFieldValue(`boxFolderId`, '');
      return false;
    }
    const getManager = await getMTEByEmail(selectedOption.email);
    if (typeof getManager == 'undefined' && profile.role.toLowerCase() != 'admin') {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Manager is not configured for selected employee, please contact admin',
        width: 400,
        height: 400,
        confirmButtonColor: '#3a7afe',
      });
      setFieldValue(`email`, '');
      setFieldValue(`manager`, '');
      setFieldValue(`employeeNumber`, '');
      setFieldValue(`boxFolderId`, '');
      return false;
    }
    setFieldValue(`manager`, getManager.manager || 'Not assigned');
    setFieldValue(`boxFolderId`, '310099883829');
    setFieldValue(`employeeNumber`, selectedOption.employeeNumber || 'NA');
    setFieldValue(`email`, selectedOption.email);
    getTuitions(selectedOption.email, moment(date || moment.toDate()).year(), setFieldValue);
  };

  const handleDatechange = async (date, setFieldValue, email = '') => {
    setFieldValue('date', date);
    if (typeof email != undefined && email != '' && email != null) {
      getTuitions(email, moment(date).year());
    }
  };

  const handleUploadBatch = async (data) => {
    const payload = {
      submitterName: profile ? profile.firstName + ' ' + profile.lastName : '',
      submitterEmail: profile.email,
      status: 'in progress',
      formType: 'aea-form',
      contractor: 'ssai',
      dynamicFields: [{ ...data }],
    };
    if (
      localStorage.getItem('formDataJSON') == null ||
      typeof localStorage.getItem('formDataJSON') == 'undefined'
    ) {
      localStorage.setItem('formDataJSON', await storeData(payload));
    }

    const formData = await retrieveData(parseInt(localStorage.getItem('formDataJSON')));

    if (formData) {
      const payload = {
        data: formData.dynamicFields,
        key: cookieValue || '',
        isBoxExplorer: hasPermission('box-folders', ['show']) || false,
      };
      try {
        showLoader();
        const response = await uploadFileBatch(payload);
        if (Array.isArray(formData.dynamicFields)) {
          formData.dynamicFields.forEach((data, index) => {
            if (index === formData.dynamicFields.length - 1) {
              dispatch(createFormAction({ ...formData, dynamicFields: data }, navigate));
            } else {
              dispatch(createFormAction({ ...formData, dynamicFields: data }, undefined));
            }
          });
        } else {
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        }

        Swal.fire({
          icon: 'success',
          title: 'Request submitted',
          text: 'Your request is submitted please wait for approver',
          width: 400,
          confirmButtonColor: '#3a7afe',
        }).then(async () => {
          await addHistory({
            email: data.email,
            year: moment(data.date).year(),
            enrolledCourses: data.enrolledCourses,
            qualifyingBenefit: data.qualifyingBenefit,
            totalTuitionAmount: data.totalTuition,
            isApproved: true,
          });
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        });
      } catch (error) {
        if (
          typeof error.response != 'undefined' &&
          typeof error.response.status != 'undefined' &&
          error.response.status == '501'
        ) {
          Swal.fire({
            icon: 'error',
            title: 'Employee Data Error',
            text: 'Employee data not exist on box, Please contact your admin',
            width: 400,
            confirmButtonColor: '#3a7afe',
          });
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Request not submitted',
            text: 'Please contact your admin',
            width: 400,
            confirmButtonColor: '#3a7afe',
          });
          console.error(
            'Error uploading file:',
            error.response ? error.response.data : error.message
          );
        }
      } finally {
        hideLoader();
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Data not existed',
        text: 'Please contact your admin',
        width: 400,
        confirmButtonColor: '#3a7afe',
      });
      hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
    }
  };

  const handleSubmit = (data) => {
    if (typeof data != 'undefined') {
      const payloadForms = {
        ...data,
        submitter: profile ? profile.firstName + ' ' + profile.lastName : '',
        employeeName: data.employeeName.value,
        attachments: attachments, // Send only the server-side filenames
        boxFolderId: '310099883829',
      };

      handleUploadBatch(payloadForms);
    }
  };

  const handleFileChange = (event, setFieldValue, currentValues, setErrors) => {
    const files = Array.from(event.target.files);
    if (files.length <= 0) {
      setFieldValue('attachments', []);
      setAttachments([]);
    }

    // Validate the files before uploading them
    const validatedFiles = files.filter((file) => {
      const isValidType = SUPPORTED_FORMATS.includes(file.type);
      const isValidSize = file.size <= 50000000; // 50MB file size limit
      return isValidType && isValidSize;
    });

    if (validatedFiles.length === 0) {
      // If no valid files, set Formik error and prevent submission
      setErrors({
        attachments:
          'No valid files selected. Please upload valid files, please select (jpeg, jpg, png, pdf).',
      });
      return;
    }

    // Append new files to the existing array of files
    const updatedFiles = currentValues.attachments
      ? [...currentValues.attachments, ...files]
      : files;

    // Update Formik field value
    setFieldValue('attachments', updatedFiles);
    // Update the selected files state to include the new files
    setAttachments((prev) => [...prev, ...files]);
    // Upload each validated file
    validatedFiles.forEach(uploadFile);
  };

  // Remove a file from the attachments
  const handleRemoveFile = (index, setFieldValue, values, file) => {
    deleteAEAFile(file.name)
      .then(() => {
        setAttachments((prevFiles) => prevFiles.filter((f) => f.name !== file.name));

        const newFiles = values.attachments.filter((_, i) => i !== index);
        setFieldValue('attachments', newFiles);
        // Clear the file input if no files are left
        if (newFiles.length === 0) {
          setFieldValue('attachments', []);
          setAttachments([]); // Clear the field as an empty array
        }

        setUploadProgress((prev) => {
          const newProgress = { ...prev };
          delete newProgress[file.name]; // Remove progress for the deleted file
          return newProgress;
        });
      })
      .catch((error) => {
        console.error('Error deleting file:', error);
      });
  };

  // Upload a single file
  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append('files', file); // Append the single file to FormData
    // Start upload for this specific file
    await axiosInstance
      .post('file/aea-uploads', formData, {
        headers: {
          'Content-Type': 'multipart/form-data', // Ensure the content type is set correctly
        },
        onUploadProgress: (progressEvent) => {
          // Safeguard to ensure total is not undefined
          if (progressEvent.total) {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            // Update the progress for this specific file using file.name
            setUploadProgress((prev) => ({
              ...prev,
              [file.name]: percentCompleted,
            }));
          }
        },
        timeout: 600000,
      })
      .then((response) => {
        const fileInfo = {
          name: response.data[0].fileName, // Get the server-generated name
          originalName: file.name, // Keep the original file name
        };
        setAttachments((prevFiles) => [
          ...prevFiles.filter((f) => f.name !== file.name), // Remove old entry if exists
          fileInfo, // Add new uploaded file info
        ]);
        setUploadProgress((prev) => ({
          ...prev,
          [file.name]: 100, // Set 100% progress after successful upload
        }));
      })
      .catch((error) => {
        console.error('Error uploading file:', error);
        // Optionally, handle the error state for the specific file
      });
  };

  return (
    <>
      <PageTitle pageTitle="Application for Educational Assistance" />
      <Card>
        <div
          className="d-flex justify-content-end"
          style={{ fontSize: '14px', fontWeight: '600', paddingBottom: '10px' }}
        >
          <Link
            className="mb-2 text-primary"
            target="_blank"
            to="https://ssaihq.app.box.com/file/1802168396849"
          >
            Instruction to Submit the AEA form
          </Link>
        </div>
        <Card.Body>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            enableReinitialize={true}
            onSubmit={handleSubmit}
          >
            {({ values, setFieldValue, setErrors, errors, touched }) => (
              <FormikForm>
                <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="employeeName">Employee Name</label>
                      <AsyncSelect
                        name="employeeName"
                        loadOptions={loadOptions}
                        defaultOptions={employeeList}
                        placeholder="Select Employee Name"
                        isSearchable
                        onChange={(selectedOption) =>
                          handleEmployeeChange(selectedOption, setFieldValue, values.date)
                        }
                      />
                      <ErrorMessage name="employeeName" component="div" className="text-danger" />
                    </div>
                  </Col>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="employeeNumber">Employee Number</label>
                      <Field
                        type="text"
                        name="employeeNumber"
                        className="form-control"
                        placeholder="Employee Number"
                        readOnly
                        value={values.employeeNumber}
                      />
                      <ErrorMessage name="employeeNumber" component="div" className="text-danger" />
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="date">Date</label>
                      <DatePicker
                        selected={values.date}
                        onChange={(date) => {
                          handleDatechange(date, setFieldValue, values.email);
                        }}
                        className="form-control"
                        dateFormat="MM/dd/yyyy"
                        placeholderText="MM/DD/YYYY"
                      />
                      <ErrorMessage name="date" component="div" className="text-danger" />
                    </div>
                  </Col>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="phoneNumber">Phone Number</label>
                      <Field
                        type="text"
                        name="phoneNumber"
                        className="form-control"
                        placeholder="123-456-7890"
                        value={values.phoneNumber}
                      />
                      <ErrorMessage name="phoneNumber" component="div" className="text-danger" />
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="major">Major</label>
                      <Field
                        type="text"
                        name="major"
                        className="form-control"
                        placeholder="Name of program or Major"
                      />
                      <ErrorMessage name="major" component="div" className="text-danger" />
                    </div>
                  </Col>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="school">School or Institution</label>
                      <Field
                        type="text"
                        name="school"
                        className="form-control"
                        placeholder="Name of Educational Institution"
                      />
                      <ErrorMessage name="school" component="div" className="text-danger" />
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="degreeType">Degree Type</label>
                      <Select
                        name="degreeType"
                        options={[
                          {
                            label: 'Undergraduate',
                            value: 'Undergraduate',
                          },
                          {
                            label: 'Graduate',
                            value: 'Graduate',
                          },
                        ]}
                        placeholder="Select Degree Type"
                        isSearchable
                        onChange={(selectedOption) =>
                          setFieldValue('degreeType', selectedOption.label)
                        }
                      />
                      <ErrorMessage name="degreeType" component="div" className="text-danger" />
                    </div>
                  </Col>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="semesterBegins">Semester Begins</label>
                      <DatePicker
                        selected={values.semesterBegins}
                        onChange={(semesterBegins) => {
                          setFieldValue('semesterBegins', semesterBegins);
                        }}
                        className="form-control"
                        dateFormat="MM/dd/yyyy"
                        placeholderText="MM/DD/YYYY"
                      />
                      <ErrorMessage name="date" component="div" className="text-danger" />
                    </div>
                  </Col>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="semesterEnds">Semester Ends</label>
                      <DatePicker
                        selected={values.semesterEnds}
                        onChange={(semesterEnds) => {
                          setFieldValue('semesterEnds', semesterEnds);
                        }}
                        className="form-control"
                        dateFormat="MM/dd/yyyy"
                        placeholderText="MM/DD/YYYY"
                      />
                      <ErrorMessage name="semesterEnds" component="div" className="text-danger" />
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="tuitionLimit">Tuition Limit ($)</label>
                      <div className="input-group">
                        <span className="input-group-text">$</span>
                        <Field
                          type="number"
                          name="tuitionLimit"
                          className="form-control"
                          placeholder="Tuition Limit"
                          min="0.00"
                          step="0.01"
                          readOnly
                          value={tuition?.totalTuitionLimit || 0}
                        />
                      </div>
                      <ErrorMessage name="tuitionLimit" component="div" className="text-danger" />
                    </div>
                  </Col>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="tuitionUsed">Tuition Used ($)</label>
                      <div className="input-group">
                        <span className="input-group-text">$</span>
                        <Field
                          type="number"
                          name="tuitionUsed"
                          className="form-control"
                          placeholder="Tuition Used"
                          min="0.00"
                          step="0.01"
                          readOnly
                        />
                      </div>
                      <ErrorMessage name="tuitionUsed" component="div" className="text-danger" />
                    </div>
                  </Col>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="tuitionBenefit">
                        Available Tuition benefit for calendar year ($)
                      </label>
                      <div className="input-group">
                        <span className="input-group-text">$</span>
                        <Field
                          type="number"
                          name="tuitionBenefit"
                          className="form-control"
                          placeholder="Tuition Used"
                          min="0.00"
                          step="0.01"
                          readOnly
                        />
                      </div>
                      <ErrorMessage name="tuitionBenefit" component="div" className="text-danger" />
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="enrolledCourses">Enrolled courses </label>
                      <Field
                        as="textarea"
                        name="enrolledCourses"
                        className="form-control"
                        placeholder="Enrolled courses separated by commas"
                        rows="4" // Adjust height by changing the number of rows
                      />
                      <ErrorMessage
                        name="enrolledCourses"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </Col>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="totalTuition">Total Tuition ($)</label>
                      <div className="input-group">
                        <span className="input-group-text">$</span>
                        <Field
                          type="number"
                          name="totalTuition"
                          className="form-control"
                          placeholder="Tuition Limit"
                          min="0.00"
                          step="0.01"
                        />
                      </div>
                      <ErrorMessage name="totalTuition" component="div" className="text-danger" />
                    </div>
                  </Col>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="qualifyingBenefit">Qualifying benefit ($)</label>
                      <div className="input-group">
                        <span className="input-group-text">$</span>
                        <Field
                          type="number"
                          name="qualifyingBenefit"
                          className="form-control"
                          placeholder="Tuition Limit"
                          min="0.00"
                          step="0.01"
                        />
                      </div>
                      <ErrorMessage
                        name="qualifyingBenefit"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col className="d-flex flex-column justify-content-start" md={6}>
                    <Form.Group>
                      <Form.Label htmlFor="custom-file">
                        Choose File
                        <strong>
                          &nbsp;&nbsp;&nbsp;&nbsp;(Please attach a copy of course description(s) and
                          proof of tuition and fee costs)
                        </strong>
                      </Form.Label>
                      <Form.Control
                        name={'attachments'}
                        id="custom-file"
                        type="file"
                        multiple
                        onChange={(e) => handleFileChange(e, setFieldValue, values, setErrors)}
                      />
                      {/* Display validation errors from Yup */}
                      {errors.attachments && touched.attachments && (
                        <div className="text-danger">
                          {/* If it's an array, map over the errors */}
                          {Array.isArray(errors.attachments) ? (
                            errors.attachments.map((error, index) => <div key={index}>{error}</div>)
                          ) : (
                            /* If it's a string (e.g., "attachments is required"), display it directly */
                            <div>{errors.attachments}</div>
                          )}
                        </div>
                      )}
                    </Form.Group>

                    {/* Display selected attachments */}
                    {values.attachments.length > 0 && (
                      <div className="mt-2">
                        <strong>Selected Files:</strong>
                        <Col md={8}>
                          <ul>
                            {attachments.map((file, index) => {
                              const progressPercentage =
                                (uploadProgress[file.name]
                                  ? uploadProgress[file.name]
                                  : uploadProgress[file.originalName]) || 0;

                              return (
                                <li
                                  key={file.name}
                                  style={{
                                    marginBottom: '10px',
                                    textAlign: 'left',
                                  }}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                    }}
                                  >
                                    <div style={{ flexGrow: 1 }}>
                                      <strong>{file.originalName}</strong> - {progressPercentage}%
                                      <progress
                                        value={progressPercentage}
                                        max="100"
                                        style={{
                                          display: 'block',
                                          width: '100%',
                                          marginTop: '5px',
                                        }} // Added margin for spacing
                                      />
                                    </div>
                                    <Badge
                                      style={{
                                        marginLeft: '20px',
                                        alignSelf: 'flex-start',
                                      }} // Align button properly
                                      variant="danger"
                                      size="sm"
                                      bg="danger"
                                      onClick={() =>
                                        handleRemoveFile(index, setFieldValue, values, file)
                                      }
                                      className="ml-2 mt-4"
                                    >
                                      <i className="fa fa-solid fa-close"></i>
                                    </Badge>
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        </Col>
                      </div>
                    )}
                  </Col>
                  <Col className="d-flex justify-content-end mt-4" style={{ paddingTop: '7px' }}>
                    <Button variant="primary" style={{ height: 'max-content' }} type="submit">
                      Submit
                    </Button>
                  </Col>
                </Row>
              </FormikForm>
            )}
          </Formik>
        </Card.Body>
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({
  profile: getProfile(state),
  employeeList: employeeSearchList(state),
});

export default connect(mapStateToProps)(AeaForm);
